import { React, useState } from "react";
import Actions from "./Actions";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import pdf from "../gerarPDF";
import { useGridApiRef } from "@mui/x-data-grid";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { ptBR } from "@mui/material/locale";
import {
  IconButton,
  InputBase,
  Stack,
  Paper,
  Button,
  Box,
  Menu,
  MenuItem,
} from "@mui/material";
import { Search, HighlightOff, Add, SyncAlt } from "@mui/icons-material";
import ExportIcon from "../../images/iconExport.svg";
import TableGridData from "../TableGridData";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

let actionOptionsGlobal = 99;
let dadosGlobal = {};

const theme = createTheme(ptBR);

const styles = {
  exportButton: {
    height: "40px",
    textTransform: "none",
    fontSize: "1rem",
    color: "#1E729F",
    borderColor: "#1E729F",
    padding: "0px 10px",
  },
  addPatient: {
    width: "215px",
    height: "40px",
    textTransform: "none",
    fontSize: "1rem",
    bgcolor: "#1E729F !important",
  },
  datagrid: {
    ".MuiDataGrid-iconButtonContainer": {
      visibility: "visible",
    },
    ".MuiDataGrid-sortIcon": {
      opacity: "inherit !important",
    },
    "& .even": {
      backgroundColor: "#D3E3EB",
    },
    "& .MuiDataGrid-row:hover": {
      backgroundColor: "#e1ebf0",
    },
    ".css-t89xny-MuiDataGrid-columnHeaderTitle": {
      color: "#1E729F",
    },
    ".css-1ioj1h0-MuiSvgIcon-root": {
      color: "#1E729F",
    },
  },
};

const defaultColumns = [
  { field: "id", headerName: "ID", width: 0, sortable: false, hide: true },
  {
    field: "nome",
    headerName: "Nome",
    flex: 1,
    minWidth: 180,
  },
  {
    field: "dataOuHorario",
    headerName: "Última consulta",
    width: 180,
  },
  {
    field: "dtNascimento",
    headerName: "Data de nascimento",
    width: 180,
    sortable: false,
  },
  {
    field: "cpf",
    headerName: "CPF",
    flex: 1,
    maxWidth: 170,
    minWidth: 120,
    sortable: false,
  },
  {
    field: "telefone",
    headerName: "Telefone",
    flex: 1,
    maxWidth: 170,
    minWidth: 140,
    sortable: false,
  },
  {
    field: "acoes",
    headerName: "Ações",
    width: 100,
    sortable: false,
    disableExport: true,
    renderCell: (params) => (
      <Actions params={params} actionOptions={actionOptionsGlobal} />
    ),
  },
];
let columns = defaultColumns;

function ExportButton({ apiRef, text = "Pacientes" }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const downloadCsv = () =>
    apiRef.current.exportDataAsCsv({
      delimiter: ";",
      fileName: "listagem_pacientes",
      utf8WithBom: true,
    });

  async function handleGerarPDF() {
    let data = {
      titulo: text,
      rows: dadosGlobal,
      columns: columns,
    };
    pdf(data)
      .then((response) => {
        pdfMake.createPdf(response).open({}, window.open("", "_blank"));
      })
      .catch((err) => {
        console.error(err, "ERRO");
      });
  }

  return (
    <>
      <Button
        id="demo-positioned-button"
        aria-controls={open ? "demo-positioned-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        variant="outlined"
        size="small"
        style={styles.exportButton}
        startIcon={<img src={ExportIcon} alt="ícone exportar" />}
      >
        Exportar
      </Button>
      <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem onClick={handleGerarPDF}>Gerar PDF</MenuItem>
        <MenuItem onClick={downloadCsv}>Gerar CSV</MenuItem>
      </Menu>
    </>
  );
}

function TableHeaderModal({
  text = "",
  value,
  onChange,
  onClickClose,
  rows,
  columns,
  apiRef,
}) {
  return (
    <Box>
      <Stack direction={"column"} sx={{ color: "#1E729F" }} spacing={2}>
        <Stack
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
          spacing={2}
        >
          <Box sx={{ color: "#1E729F", fontSize: "20px", fontWeight: "700" }}>
            {text}
          </Box>
          <Stack spacing={2} direction={"row"} alignItems={"center"}>
            <ExportButton apiRef={apiRef} text={text} />
            <IconButton
              type="button"
              sx={{ p: "10px" }}
              aria-label="close"
              onClick={onClickClose}
            >
              <HighlightOff sx={{ color: "#1E729F" }} fontSize="large" />
            </IconButton>
          </Stack>
        </Stack>
        <Paper
          component="form"
          sx={{
            p: "2px 4px",
            display: "flex",
            alignItems: "center",
            width: "100%",
          }}
        >
          <InputBase
            sx={{ ml: 1, flex: 1 }}
            placeholder="Procurar por nome ou CPF"
            inputProps={{ "aria-label": "procurar por nome ou cpf" }}
            value={value}
            onChange={onChange}
          />
          <IconButton type="button" sx={{ p: "10px" }} aria-label="search">
            <Search />
          </IconButton>
        </Paper>
      </Stack>
    </Box>
  );
}

function TableHeader({ value, onChange, rows, columns, apiRef }) {
  const navigate = useNavigate();
  function handleAddPatient() {
    navigate("/cadastro-paciente");
  }
  return (
    <Box>
      <Stack
        sx={{ color: "#1E729F" }}
        spacing={2}
        justifyContent={"space-between"}
      >
        <Paper
          component="form"
          sx={{
            p: "2px 4px",
            display: "flex",
            alignItems: "center",
            height: "40px",
            border: "1px solid #1E729F",
            boxShadow: "none",
          }}
        >
          <InputBase
            sx={{ ml: 1, flex: 1 }}
            placeholder="Procurar por nome ou cpf"
            inputProps={{ "aria-label": "procurar por nome ou cpf" }}
            value={value}
            onChange={onChange}
          />
          <IconButton type="button" sx={{ p: "10px" }} aria-label="search">
            <Search sx={{ color: "#1E729F" }} />
          </IconButton>
        </Paper>
        <Stack spacing={2} direction={"row"} justifyContent={"flex-end"}>
          <ExportButton apiRef={apiRef} />
          <Button
            variant="contained"
            size="small"
            startIcon={<Add />}
            sx={styles.addPatient}
            onClick={handleAddPatient}
          >
            Adicionar paciente
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
}

export function SortedDescendingIcon() {
  return (
    <SyncAlt
      className="icon"
      sx={{ transform: "rotate(90deg)" }}
      fontSize="small"
    />
  );
}

export function SortedAscendingIcon() {
  return (
    <SyncAlt
      className="icon"
      sx={{ transform: "rotate(90deg)" }}
      fontSize="small"
    />
  );
}

export default function PatientsList({
  isModal = false,
  textModal = "",
  setOpenModal,
  actionOptions,
  openModal,
  dados,
  dataColumns = [],
}) {
  dadosGlobal = dados;

  if (dataColumns.length > 0) {
    columns = dataColumns.concat(defaultColumns[defaultColumns.length - 1]);
  } else {
    columns = defaultColumns;
  }

  const [searchValue, setSearchValue] = useState("");

  if (openModal) {
    actionOptionsGlobal = actionOptions;
  }

  const apiRef = useGridApiRef();

  function updateSearchValue(newValue) {
    apiRef.current.setQuickFilterValues(
      newValue.split(" ").filter((word) => word !== "")
    );
  }

  function handleSearchValueChange(event) {
    const newValue = event.target.value;
    setSearchValue(newValue);
    updateSearchValue(newValue);
  }

  return (
    <ThemeProvider theme={theme}>
      <Paper
        component="div"
        sx={{
          p: "15px",
          alignItems: "center",
          width: "100%",
          boxShadow: "0px 0px 5px 4px rgba(217,217,217,0.3)",
        }}
      >
        <Stack direction={"column"} spacing={2}>
          {isModal ? (
            <TableHeaderModal
              text={textModal}
              value={searchValue}
              onChange={handleSearchValueChange}
              onClickClose={setOpenModal}
              columns={columns}
              rows={dados}
              apiRef={apiRef}
            />
          ) : (
            <TableHeader
              value={searchValue}
              onChange={handleSearchValueChange}
              columns={columns}
              rows={dados}
              apiRef={apiRef}
            />
          )}

          {dados && (
            <TableGridData rows={dados} columns={columns} apiRef={apiRef} />
          )}
        </Stack>
      </Paper>
    </ThemeProvider>
  );
}
